import React, { useEffect, useState } from "react"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Table,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input,
    Badge,
} from "reactstrap"
import { connect } from "react-redux"
import {
    setBreadcrumbItems,
    getSupplierInvoices,
    addNewSupplierInvoice,
    getSuppliers
} from "../../store/actions"
import { useFormik } from "formik"
import * as Yup from "yup"
import moment from "moment"
import { getAllSuppliers } from "../../helpers/fakebackend_helper"

const SupplierInvoices = props => {
    document.title = "Factures Fournisseurs | CRM Entreprise"

    const { invoices, getSupplierInvoices, addNewSupplierInvoice } = props
    const [modal, setModal] = useState(false)
    const [supplierList, setSupplierList] = useState([])
    const [selectedFile, setSelectedFile] = useState(null)
    const API_STORAGE_URL = process.env.REACT_APP_API_URL?.replace('/api', '/storage/')

    const breadcrumbItems = [
        { title: "Fournisseurs", link: "#" },
        { title: "Factures", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Factures Fournisseurs", breadcrumbItems)
        getSupplierInvoices()
        loadSuppliers()
    }, [])

    const loadSuppliers = async () => {
        try {
            const data = await getAllSuppliers()
            setSupplierList(data)
        } catch (e) {
            console.error("Failed to load suppliers", e)
        }
    }

    const toggle = () => {
        setModal(!modal)
        if (modal) {
            setSelectedFile(null)
        }
    }

    const formik = useFormik({
        initialValues: {
            supplier_id: "",
            invoice_number: "",
            invoice_date: moment().format("YYYY-MM-DD"),
            due_date: "",
            amount: "",
            status: "pending",
            notes: "",
        },
        validationSchema: Yup.object({
            supplier_id: Yup.string().required("Fournisseur obligatoire"),
            invoice_number: Yup.string().required("N° facture obligatoire"),
            amount: Yup.number().required("Montant obligatoire"),
        }),
        onSubmit: (values) => {
            const formData = new FormData()
            Object.keys(values).forEach(key => {
                formData.append(key, values[key])
            })
            if (selectedFile) {
                formData.append("file", selectedFile)
            }
            addNewSupplierInvoice(formData)
            toggle()
        },
    })

    const getStatusBadge = (status) => {
        switch (status) {
            case 'paid': return <Badge color="success">Payé</Badge>
            case 'pending': return <Badge color="warning">En attente</Badge>
            case 'cancelled': return <Badge color="danger">Annulé</Badge>
            default: return status
        }
    }

    return (
        <React.Fragment>
            <div className="container-fluid">
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody>
                                <div className="d-flex align-items-center mb-4">
                                    <div className="flex-grow-1">
                                        <h4 className="card-title">Factures Recus</h4>
                                    </div>
                                    <div className="flex-shrink-0">
                                        <Button color="primary" onClick={toggle}>
                                            <i className="mdi mdi-upload me-1"></i> Enregistrer une facture
                                        </Button>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <Table className="table-centered table-nowrap mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>N° Facture</th>
                                                <th>Fournisseur</th>
                                                <th>Date</th>
                                                <th>Échéance</th>
                                                <th>Montant</th>
                                                <th>Statut</th>
                                                <th>Document</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(invoices.data || []).map((invoice, key) => (
                                                <tr key={key}>
                                                    <td>{invoice.invoice_number}</td>
                                                    <td>
                                                        <h5 className="font-size-14 mb-0">{invoice.supplier?.name}</h5>
                                                    </td>
                                                    <td>{moment(invoice.invoice_date).format("DD/MM/YYYY")}</td>
                                                    <td>{invoice.due_date ? moment(invoice.due_date).format("DD/MM/YYYY") : "-"}</td>
                                                    <td>{invoice.amount} MAD</td>
                                                    <td>{getStatusBadge(invoice.status)}</td>
                                                    <td>
                                                        {invoice.file_path ? (
                                                            <a
                                                                href={`${API_STORAGE_URL}${invoice.file_path}`}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                className="btn btn-sm btn-info"
                                                            >
                                                                <i className="mdi mdi-file-pdf-outline me-1"></i> Voir
                                                            </a>
                                                        ) : "N/A"}
                                                    </td>
                                                </tr>
                                            ))}
                                            {(!invoices.data || invoices.data.length === 0) && (
                                                <tr>
                                                    <td colSpan="7" className="text-center">Aucune facture enregistrée.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={modal} toggle={toggle} size="lg">
                    <ModalHeader toggle={toggle}>Enregistrer une Facture Fournisseur</ModalHeader>
                    <ModalBody>
                        <Form onSubmit={(e) => { e.preventDefault(); formik.handleSubmit(); }}>
                            <Row>
                                <Col lg="6">
                                    <FormGroup className="mb-3">
                                        <Label>Fournisseur</Label>
                                        <Input
                                            name="supplier_id"
                                            type="select"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.supplier_id}
                                            invalid={formik.touched.supplier_id && formik.errors.supplier_id ? true : false}
                                        >
                                            <option value="">Sélectionner...</option>
                                            {supplierList.map((s, i) => (
                                                <option key={i} value={s.id}>{s.name}</option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col lg="6">
                                    <FormGroup className="mb-3">
                                        <Label>Numéro de Facture</Label>
                                        <Input
                                            name="invoice_number"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.invoice_number}
                                            invalid={formik.touched.invoice_number && formik.errors.invoice_number ? true : false}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="4">
                                    <FormGroup className="mb-3">
                                        <Label>Date de Facture</Label>
                                        <Input
                                            name="invoice_date"
                                            type="date"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.invoice_date}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="4">
                                    <FormGroup className="mb-3">
                                        <Label>Date d'Échéance</Label>
                                        <Input
                                            name="due_date"
                                            type="date"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.due_date}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="4">
                                    <FormGroup className="mb-3">
                                        <Label>Montant (MAD)</Label>
                                        <Input
                                            name="amount"
                                            type="number"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.amount}
                                            invalid={formik.touched.amount && formik.errors.amount ? true : false}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="6">
                                    <FormGroup className="mb-3">
                                        <Label>Statut</Label>
                                        <Input
                                            name="status"
                                            type="select"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.status}
                                        >
                                            <option value="pending">En attente</option>
                                            <option value="paid">Payé</option>
                                            <option value="cancelled">Annulé</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col lg="6">
                                    <FormGroup className="mb-3">
                                        <Label>Fichier (PDF, Image)</Label>
                                        <Input
                                            type="file"
                                            onChange={(e) => setSelectedFile(e.target.files[0])}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="12">
                                    <FormGroup className="mb-3">
                                        <Label>Notes</Label>
                                        <Input
                                            name="notes"
                                            type="textarea"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.notes}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="text-end">
                                <Button type="submit" color="primary">
                                    Enregistrer la facture
                                </Button>
                            </div>
                        </Form>
                    </ModalBody>
                </Modal>

            </div>
        </React.Fragment >
    )
}

const mapStateToProps = ({ Suppliers }) => ({
    invoices: Suppliers.invoices,
})

export default connect(mapStateToProps, {
    setBreadcrumbItems,
    getSupplierInvoices,
    addNewSupplierInvoice
})(SupplierInvoices)
